import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form/dist/index.ie11';
import { Stack } from '@grubhubprod/gh-cookbook-react';
import { OptionsCheckboxes } from './OptionsCheckboxes';
import { EmailNotificationsControl } from './EmailNotificationsControl';
import { PGPEncryptionControl } from './PGPEncryptionControl';
import { SFTPControl } from './SFTPControl';

export const PGPEncryptionBody = `Will the client’s employee and expense code files be encrypted with 
PGP? Note that if you select Yes, both the employee and the expense 
code CSV files must be encrypted with PGP.`;

export function SFTPWrapper(): JSX.Element {
  const { control } = useFormContext();

  const showSFTPDetails = useWatch({
    control,
    name: 'enableSFTP',
  }) as boolean;

  return (
    <div>
      <Stack y="x-sm">
        <SFTPControl name="enableSFTP" id="enableSFTP" />
      </Stack>
      {showSFTPDetails && (
        <>
          <OptionsCheckboxes />
          <Stack y="x-sm">
            <EmailNotificationsControl
              name="sftpNotificationEmailsString"
              id="sftpNotificationEmailsString"
            />
          </Stack>
          <Stack y="x-sm">
            <PGPEncryptionControl
              name="fileEncryptionEnabled"
              id="fileEncryptionEnabled"
              heading="PGP Encryption"
              body={PGPEncryptionBody}
            />
          </Stack>
        </>
      )}
    </div>
  );
}
